import { Controller } from "@hotwired/stimulus";
import debounce from "debounce";

// Connects to data-controller="autosubmit"
export default class extends Controller {
  #lastComboboxValues = {}

  initialize() {
    this.debouncedSubmit = debounce(this.debouncedSubmit.bind(this), 300);
  }

  connect() {
    this.#lastComboboxValues = {}
    this.element.querySelectorAll("[data-hw-combobox-target='hiddenField']").forEach((input) => {
      this.#lastComboboxValues[input.name] = String(input.value ?? "")
    })
  }

  submit(event) {
    if (event?.type === "hw-combobox:selection") {
      if (this.#unchangedComboboxSelection(event)) return

      this.#rememberComboboxSelection(event)

      // Mobile combobox closes its dialog in this turn; requestSubmit in the
      // same turn races the dialog teardown.
      setTimeout(() => {
        if (this.element.isConnected) this.element.requestSubmit();
      }, 0);
      return;
    }

    this.element.requestSubmit();
  }

  debouncedSubmit() {
    this.submit();
  }

  #unchangedComboboxSelection(event) {
    const value = this.#comboboxEventValue(event)
    if (value === undefined) return false

    return this.#lastComboboxValues[this.#comboboxFieldName(event)] === value
  }

  #rememberComboboxSelection(event) {
    const value = this.#comboboxEventValue(event)
    if (value === undefined) return

    this.#lastComboboxValues[this.#comboboxFieldName(event)] = value
  }

  #comboboxFieldName(event) {
    return event.detail?.fieldName || "combobox"
  }

  #comboboxEventValue(event) {
    if (!event?.detail || !Object.hasOwn(event.detail, "value")) return undefined

    return String(event.detail.value ?? "")
  }
}
